import { render, staticRenderFns } from "./UserEducationEdit.vue?vue&type=template&id=3fa3b2bc"
import script from "./UserEducationEdit.js?vue&type=script&lang=js&external"
export * from "./UserEducationEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports